/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Request to update an existing draft note
 * @export
 * @interface InternalApiUpdateNoteDraft
 */
export interface InternalApiUpdateNoteDraft {
    /**
     * 
     * @type {string}
     * @memberof InternalApiUpdateNoteDraft
     */
    content: string;
}

/**
 * Check if a given object implements the InternalApiUpdateNoteDraft interface.
 */
export function instanceOfInternalApiUpdateNoteDraft(value: object): value is InternalApiUpdateNoteDraft {
    if (!('content' in value) || value['content'] === undefined) return false;
    return true;
}

export function InternalApiUpdateNoteDraftFromJSON(json: any): InternalApiUpdateNoteDraft {
    return InternalApiUpdateNoteDraftFromJSONTyped(json, false);
}

export function InternalApiUpdateNoteDraftFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiUpdateNoteDraft {
    if (json == null) {
        return json;
    }
    return {
        
        'content': json['content'],
    };
}

export function InternalApiUpdateNoteDraftToJSON(json: any): InternalApiUpdateNoteDraft {
    return InternalApiUpdateNoteDraftToJSONTyped(json, false);
}

export function InternalApiUpdateNoteDraftToJSONTyped(value?: InternalApiUpdateNoteDraft | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'content': value['content'],
    };
}

